import type { ReactNode } from 'react'
import * as stylex from '@stylexjs/stylex'

const styles = stylex.create({
  root: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', paddingBlock: '28px', textAlign: 'center' },
  icon: { display: 'flex', height: '44px', width: '44px', alignItems: 'center', justifyContent: 'center', borderRadius: '9999px', backgroundColor: '#edf6eb', color: '#468554' },
  title: { fontSize: '16px', fontWeight: 650, color: '#27342b' },
  description: { maxWidth: '32rem', color: '#748077', fontSize: '12px', lineHeight: '1.2rem' },
  action: { marginTop: '4px' },
})

type EmptyStateProps = {
  action?: ReactNode
  description: string
  icon?: ReactNode
  title?: string
}

export default function EmptyState({ action, description, icon, title }: EmptyStateProps) {
  return <div {...stylex.props(styles.root)}>{icon && <span {...stylex.props(styles.icon)}>{icon}</span>}{title && <h2 {...stylex.props(styles.title)}>{title}</h2>}<p {...stylex.props(styles.description)}>{description}</p>{action && <div {...stylex.props(styles.action)}>{action}</div>}</div>
}
